import { Label } from 'views/components/atoms/label';
import { ListBodyCellType } from 'views/components/atoms/listCell';
import { BodyShowList } from 'views/components/molecules/listBody';
import { BgColors } from 'views/constants/enums/bgColors';
import { GetNotificationListQuery } from 'views/utils/graphql/graphql';

export const createBodyShowLists = (needConfirmStatus: boolean, data: GetNotificationListQuery) => {
  if (!data.GetNotificationList?.Data) return [];

  const createdBodyShowLists: BodyShowList[] = data.GetNotificationList?.Data?.map((item) =>
    [
      {
        type: ListBodyCellType.labelCell,
        label: item?.Importance !== null && <div>{checkImportanceLabel(item?.Importance)}</div>,
      },
      {
        type: ListBodyCellType.labelCell,
        label: item?.DeliveryTarget && <div>{checkNoticeLabel(item?.DeliveryType)}</div>,
      },
      {
        type: ListBodyCellType.nameCell,
        label: <div>{item?.Title}</div>,
      },
      needConfirmStatus
        ? {
            type: ListBodyCellType.confirmCell,
            label: <div>{item?.Confirmed ? '確認済み' : '未確認'}</div>,
          }
        : null,
      {
        type: ListBodyCellType.dateCell,
        label: <div>{item?.PublishStartDate}</div>,
      },
    ].filter((x) => x != null),
  ) as BodyShowList[];
  return createdBodyShowLists;
};

export const checkNoticeLabel = (status: number) => {
  switch (status) {
    case 1:
      return <Label backgroundColor={BgColors.Primary} content={'FPG証券'} />;
    case 2:
      return <Label backgroundColor={BgColors.Secondary} content={'FPG信託'} />;
    default:
      <div>-</div>;
  }
};

// TODO: どのくらい重要度で色分けするか
export const checkImportanceLabel = (status?: number) => {
  switch (status) {
    case 2:
      return <Label backgroundColor={BgColors.Danger} content="重要" />;
    default:
      return <></>;
  }
};
